import { MMKV } from "react-native-mmkv";

const mmkv = new MMKV();
export default mmkv;
